import { render, staticRenderFns } from "./OrderlistManagement.vue?vue&type=template&id=3c99e537&scoped=true"
import script from "./OrderlistManagement.vue?vue&type=script&lang=js"
export * from "./OrderlistManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderlistManagement.vue?vue&type=style&index=0&id=3c99e537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99e537",
  null
  
)

export default component.exports